import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { LoaderService } from '../../../core/services/loader/loader.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [
    CommonModule,
    ProgressSpinnerModule,

  ],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent implements OnDestroy {
  isLoading = true; // Initial state
  private subscription: Subscription;
  loading$: Observable<boolean>; // Declare loading$ here

  constructor(private loaderService: LoaderService) {
    this.loading$ = this.loaderService.loading$; // Initialize after loaderService
    this.subscription = this.loaderService.loading$.subscribe((loading) => {
      this.isLoading = loading;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe(); // Prevent memory leaks
    }
  }
}
